import { render } from "./ModalNuevoTipoEvento.vue?vue&type=template&id=f061f034"
import script from "./ModalNuevoTipoEvento.vue?vue&type=script&lang=js"
export * from "./ModalNuevoTipoEvento.vue?vue&type=script&lang=js"

import "./ModalNuevoTipoEvento.vue?vue&type=style&index=0&id=f061f034&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__